import { deleteCookie, getCookie } from './cookies'

import { Buffer } from 'buffer'
import { CUSTOM_AGENCIES_PERMISSIONS } from '../apps/saas/constants'
import { ProductType } from '../pmd/components/payments/product.type'
import { USER_ROLE } from '../models/user'
import { agencyLaunchpadRoutes } from '../routes/constants/agency'
import { aiEmployeePromoRoutes } from '../routes/constants/agency/'
import config from '../config'
import { conversationAIRouteNames } from '../routes/constants/location/'
import { i18n } from '@/localization'
import isArray from "lodash-es/isArray"
import isEmpty from 'lodash-es/isEmpty'
import isObject from "lodash-es/isObject"
import { launchPadRouteNames } from '../routes/constants/location/launchpad'
import moment from 'moment'
import { parsePhoneNumber } from "libphonenumber-js";
import { shouldHideLaunchpad } from '../pmd/composition/userPermission'
import snakeCase from "lodash-es/snakeCase"
import { snapshotsRoutes } from '../routes/constants/agency/snapshots'
import { useStore } from '../store'

const currencySymbols = {
  'USD': '$',
  'GBP': '£',
  'EUR': '€',
  'INR': '₹',
}

export const getCurrencySymbol = (code: any) => {
  return currencySymbols[code] || code + ' '
}

export const restrictUserByAgencyPermission = (locationPermissions, companyId, route) => {
  const customAgencyConfig = CUSTOM_AGENCIES_PERMISSIONS[companyId];
  if(customAgencyConfig && customAgencyConfig.routes.includes(route) && locationPermissions?.custom_changes_enabled) {
    return true;
  }
  return false
}

export const restrictUserByScopePermission = (scopes: string[], scope: string, route: string) => {
  if(!(scopes || []).includes(scope) && route === snapshotsRoutes.default) {
    return true;
  }
  return false
}

export const getValidUrl = (url = '') => {
  if (!url) return url
  let newUrl = decodeURIComponent(url)
  newUrl = newUrl.trim().replace(/\s/g, '')
  if (/^(:\/\/)/.test(newUrl)) {
    return `http${newUrl}`
  }
  if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
    return `https://${newUrl}`
  }
  return newUrl
}

export function getHostAndDomain() {
  let host
  // if (window.location.host.indexOf('localhost') === -1) {
  host = window.location.host
  // Remove the dot at end of the value, so that only whitelale domain value will be passed to brand api.
  host = host.replace(/\.$/, "");
  // } else {
  //     host = 'illinitechs.gohighlevel.com';
  // }

  return {
    domain: host,
    subdomain: host.substr(0, host.indexOf('.') || host.length)
  }
}

export const isURL = (url: any) => {
  if (!url || !url.length) return

  const regExp = /([--:\w?@%&+~#=]*\.[a-z]{2,4}\/{0,2})((?:[?&](?:\w+)=(?:\w+))+|[--:\w?@%&+~#=]+)?/
  const match = url.match(regExp)
  return match && match.length
}

export const copyTextToClipboard = (text: string) => {
  const textElem = document.createElement('textarea')
  textElem.innerHTML = text
  document.body.appendChild(textElem)
  textElem.select()
  document.execCommand('copy')
  navigator.clipboard.writeText(textElem.value);
  document.body.removeChild(textElem)
}

export const isSafari = () => {
  return navigator.vendor.toLowerCase().indexOf('apple') > -1
}

export const trackGaEvent = (
  eventCategory: string,
  eventAction: string,
  eventLabel?: string,
  eventValue?: number
) => {
  // Refer to this doc: https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#events
  if (config.googleAnalyticId && window.ga) {
    window.ga(
      'send',
      'event',
      eventCategory,
      eventAction,
      eventLabel || '',
      eventValue || 1
    )
  } else {
    console.table({ 'GA Info': '[Only in Dev Mode]', eventCategory, eventAction, eventLabel, eventValue })
  }
  // To test, add these line, in enviroment configurations:
  // googleAnalyticId: 'UA-115177999-2',

}

export const trackGaPageView = (
  pageName: string,
) => {
  // Refer to this doc: https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#events
  if (config.googleAnalyticId && window.ga) {
    window.ga('set', 'page', pageName || '');
    window.ga( 'send','pageview')
  }
  // To test, add these line, in enviroment configurations:
  // googleAnalyticId: 'UA-115177999-2',

}


export const SnapshotAssetMapper: any = {
  text_templates: 'Text & Email Templates',
  email_templates: 'Email Builder Templates',
  funnels: 'Funnels & Websites',
  links: 'Trigger Links',
  conversation_ai: 'Conversation AI',
  whatsapp_templates: 'WhatsApp Templates',
  ad_campaigns: 'Ad Campaigns - Meta',
  google_ad_campaigns: 'Ad Campaigns - Google'
}

export const trackPendoEvent = (
  eventName: string,
  eventProperties: {[key: string]: any}
) => {
  try {
    if (config.mode === 'production') {
      const store = useStore()
      if (store.getters['auth/isSupportAgent']) {
        // do not track pendo event for support user
        return
      }
      if (window.pendo) {
        window.pendo.track(eventName, eventProperties)
      }
    } else {
      // console.table({
      //   'PENDO Object': '[only in dev mode]',
      //   eventName,
      //   ...eventProperties,
      // })
    }
  } catch {
    // console.error('Error in tracking pendo event', error)
  }
}

export const handleJobberLeadSourceCookie = (newCompany: any, oldCompany: any) => {
  const leadSourceCookie = getCookie('lead_source')
  if (leadSourceCookie === 'jobber' && newCompany && !oldCompany) {

    // Track Pendo event with retry mechanism for Jobber lead source
    const trackJobberPendoEvent = () => {
      const eventName = 'New Jobber GHL agency'
      const eventProperties = {
        timestamp: new Date().toISOString(),
        source: 'login_successful'
      }

      try {
        if (config.mode === 'production') {
          if (window.pendo) {
            window.pendo.track(eventName, eventProperties)
            deleteCookie('lead_source')
          } else {
            const maxRetries = 6
            let retryCount = 0

            const retryInterval = setInterval(() => {
              retryCount++

              if (window.pendo) {
                window.pendo.track(eventName, eventProperties)
                deleteCookie('lead_source')
                clearInterval(retryInterval)
              } else if (retryCount >= maxRetries) {
                clearInterval(retryInterval)
              }
            }, 30000)
          }
        } else {
          console.table({
            'PENDO Object': '[only in dev mode]',
            eventName,
            ...eventProperties,
          })
          deleteCookie('lead_source')
        }
      } catch (error) {
        // console.error('Error in tracking Jobber pendo event', error)
      }
    }

    trackJobberPendoEvent()
  }
}


export const getMainDomain = (): string => {
  const hostname = window.location.hostname
  const domainParts = hostname.split('.')
  return domainParts.length > 2 ? domainParts.slice(-2).join('.') : hostname
}


export const setJobberLeadSourceAndRedirect = (): void => {
  const expiryDate = new Date()
  expiryDate.setDate(expiryDate.getDate() + 30)

  const mainDomain = getMainDomain()
  document.cookie = `lead_source=jobber; expires=${expiryDate.toUTCString()}; path=/; domain=.${mainDomain}; secure`

  window.location.href = 'https://www.gohighlevel.com/jobber?fp_ref=jobber57'
}

export const createPriceParams = (
  price: any
) => {
  const priceParams = {
    name: price.name,
    type: price.type,
    currency: price.currency,
    amount: price.amount,
  }

  if (price.hasOwnProperty('description')) priceParams.description = price.description
  if (price.membershipOffers) priceParams.membershipOffers = price.membershipOffers

  if (price.type === ProductType.RECURRING) {
    if (price.recurring) priceParams.recurring = price.recurring
    if (price.trialPeriod) priceParams.trialPeriod = Number(price.trialPeriod)
    if (price.setupFee) priceParams.setupFee = price.setupFee
    if (price.totalCycles) priceParams.totalCycles = price.totalCycles
  }

  return priceParams
}


export function getFriendlyNumber(no: number){
  if(Number.isInteger(no)){
    return no;
  }else{
    return no.toFixed(2)
  }
}

export function wordpressPlans(){
  const plans = [
    'FOUNDER_SPECIAL',
    'UNLIMITED_MONTHLY',
    'UNLIMITED_YEARLY'
  ]
  return {
    plans,
    labelMap:{
      FOUNDER_SPECIAL: 'Founder\'s Special Offer',
      UNLIMITED_MONTHLY: 'Unlimited Monthly Plan',
      UNLIMITED_YEARLY: 'Unlimited Yearly Plan',
      STANDARD: 'Standard'
    }
  }

}

export function sanitizeDomain(domain: string = ''){
  domain = domain.trim();
  domain = domain.replace(/(\s*\.+\s*)+$/g,'');
  domain = domain.replace(/(\s*\/+\s*)+$/g,'');
  return domain;
}

export function stripDomainProtocol(domain: string = ''){
  domain = domain.trim();
  domain = domain.replace(/^https*\:\/\//,'').trim()
  return domain;
}

export function addHttps(domain: string = ''){
  domain = `https://${stripDomainProtocol(domain)}`
  return domain;
}

export function promiseRace(anyPromise:Promise<any>, timeout:number ){
  return Promise.race([
    anyPromise,
    new Promise((_,reject)=>{
      setTimeout(()=>{
        reject(`Timeout exceed ${timeout}`)
      }, timeout)
    })
  ])
}


const toCamel = function (string) {
  return string.replace(/([a-z0-9])[_]([a-z])/g, function (g) {
    return g[0] + g[2].toUpperCase()
  })
}

export const transformToCamelCase = function (data: any) {
  if (data instanceof Date || data instanceof Buffer || data === null || data === undefined || (typeof data === 'object' && Object.keys(data).length === 0)) {
    return data
  }
  if (data instanceof Array) {
    return data.map((datum) => transformToCamelCase(datum))
  }
  if (data instanceof Object) {
    const transformedObject = {}

    Object.keys(data).forEach((field) => {
      let dataField: any = data[field]

      if (dataField && dataField._seconds !== undefined && dataField._nanoseconds !== undefined) {
        dataField = new Date(dataField._seconds * 1000 + dataField._nanoseconds / 1000000)
      }

      if (dataField instanceof Object) {
        dataField = transformToCamelCase(dataField)
      }

      transformedObject[toCamel(field)] = dataField
    })

    return transformedObject
  }
  return data
}

export function capitalizeFirstLetter(str: string) {
  return str[0].toUpperCase() + str.slice(1);
}

export const capitalizeWordsFirstLetter = (str: string) => {
  return str?.replace(/\b\w/g, (char) => char.toUpperCase()) || ''
}

/**
 * Formats a label according to the specified format type
 * Uses switch case for different format conversions
 * @param label - The label to format
 * @param format - The format type to apply ('uppercase', 'lowercase', 'titlecase', 'mixed')
 * @param formatter - Optional custom formatter function (defaults to capitalizeWordsFirstLetter)
 * @returns The formatted label according to the specified format
 */
export const formatLabelToMatchReference = (label: string, format: 'uppercase' | 'lowercase' | 'titlecase' | 'mixed', formatter: (label: string) => string = capitalizeWordsFirstLetter): string => {
  // Handle edge cases
  if (!label?.trim()) return ''

  const trimmedLabel = label.trim()

  switch (format) {
    case 'uppercase':
      return trimmedLabel.toUpperCase()

    case 'lowercase':
      return trimmedLabel.toLowerCase()

    case 'titlecase':
      return formatter(trimmedLabel)

    case 'mixed':
    default:
      return formatter(trimmedLabel)
  }
}


export function parseReportingData(data: any) {
  return data.map((obj: any) => {
    const parsedObj: any = {};
    if (obj.adName) parsedObj.adName = obj.adName;
    if(obj.campaign) {
      parsedObj.campaignId = obj.campaign.id;
      parsedObj.campaignName = obj.campaign.name;
      parsedObj.campaignStatus = obj.campaign.status || '';
      parsedObj.campaignStatusText = obj.campaign.status ? capitalizeFirstLetter(obj.campaign.status.toLowerCase()) : '';
    }
    if(obj.adGroup) {
      parsedObj.adGroupId = obj.adGroup.id;
      parsedObj.adGroupName = obj.adGroup.name;
    }
    if(obj.adGroupAd) {
      parsedObj.adId = obj.adGroupAd.ad ? obj.adGroupAd.ad.id : obj.adGroupAd.id;
      if (obj.adGroupAd.status) parsedObj.adStatus = obj.adGroupAd.status;
      parsedObj.ad = {...(obj.adGroupAd?.ad?.data || obj.adGroupAd?.ad || {})}
      if(!parsedObj.ad.name) parsedObj.ad.name = parsedObj.adName || (parsedObj.ad.headlines ? parsedObj.ad.headlines[0].text : '');
      if(parsedObj.ad.descriptions?.length) {
        parsedObj.ad.description = parsedObj.ad.descriptions.reduce((text: string, curr: any) => {
          return text += text.length ? ` | ${curr.text}` : curr.text
        }, '');
      }
      if(parsedObj.ad.headlines?.length) {
        if(!parsedObj.ad.description) parsedObj.ad.description = '';
        parsedObj.ad.description += parsedObj.ad.headlines.reduce((text: string, curr: any) => {
          return text += text.length ? ` | ${curr.text}` : curr.text
        }, '');
      }
      parsedObj.ad.finalUrl = obj.adGroupAd?.ad?.finalUrls ? obj.adGroupAd.ad.finalUrls[0] : null;
    }
    if(obj.adGroupCriterion && obj.adGroupCriterion.keyword) {
      parsedObj.keyword = obj.adGroupCriterion.keyword.text || '--'
    }
    if(obj.metrics) {
      for(const key of Object.keys(obj.metrics)) {
        parsedObj[key] = obj.metrics[key]
      }
    }
    if (parsedObj.clicks) parsedObj.clicks = parseInt(parsedObj.clicks, 10);
    if (parsedObj.averageCpc) parsedObj.averageCpc = parseInt(parsedObj.averageCpc, 10) / 1000000;
    if (parsedObj.viewThroughConversions) parsedObj.viewThroughConversions = parseInt(parsedObj.viewThroughConversions, 10);
    if (parsedObj.costMicros) parsedObj.costMicros = parseInt(parsedObj.costMicros, 10) / 1000000;
    if (parsedObj.impressions) parsedObj.impressions = parseInt(parsedObj.impressions, 10);
    if (parsedObj.conversions) parsedObj.conversions = parseFloat(parsedObj.conversions);
    if (parsedObj.ctr) parsedObj.ctr = parsedObj.ctr * 100;
    if (parsedObj.conversionsFromInteractionsRate) parsedObj.conversionsFromInteractionsRate =
      parseFloat(parsedObj.conversionsFromInteractionsRate);
    if (parsedObj.costPerConversion) parsedObj.costPerConversion = parseInt(parsedObj.costPerConversion, 10) / 1000000;
    return parsedObj;
  });
}

export const formatNumber = (value: any) => {
  return new Intl.NumberFormat(
    navigator.language,
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(value))
}

export const formatDecimal = (value: any) => {
  return new Intl.NumberFormat(
    navigator.language,
    {
      style: 'decimal'
    }).format(Number(value))
}

export const formatPercent = (value: any) => {
  return new Intl.NumberFormat(
    navigator.language,
    {
      style: 'percent',
      minimumFractionDigits: 2
    }).format(Number(value))
}

export const locationNicheOptions = [
  {
    label: i18n.global.t('common.financialServices'),
    value: 'finance',
    icon: 'far fa-money-bill-alt',
  },
  {
    label: i18n.global.t('common.marketingAdvertising'),
    value: 'marketing',
    icon: 'fas fa-bullhorn',
  },
  {
    label: i18n.global.t('common.fitnessLifestyle'),
    value: 'fitness',
    icon: 'fas fa-heartbeat',
  },
  {
    label: i18n.global.t('common.healthMedical'),
    value: 'health',
    icon: 'fas fa-medkit',
  },
  {
    label: i18n.global.t('common.onlineTrainingEducation'),
    value: 'education',
    icon: 'fas fa-university',
  },
  {
    label: i18n.global.t('common.realEstate'),
    value: 'real_estate',
    icon: 'far fa-building',
  },
  {
    label: i18n.global.t('common.homeServices'),
    value: 'home_services',
    icon: 'fas fa-home',
  },
  {
    label: i18n.global.t('common.restaurants'),
    value: 'restaurants',
    icon: 'fas fa-pizza-slice',
  },
  {
    label: i18n.global.t('common.legalServices'),
    value: 'legal',
    icon: 'fas fa-balance-scale',
  },
  {
    label: i18n.global.t('common.retailEcommerce'),
    value: 'retail',
    icon: 'fas fa-truck',
  },
  {
    label: i18n.global.t('common.others'),
    value: 'others',
    icon: 'fas fa-ellipsis-h',
  },
]

export const A2PCampaignUseCaseOptions = [
  {
    label: i18n.global.t('common.lowVolumeMixedRecommended'),
    value: 'LOW_VOLUME'
  },
  {
    label: i18n.global.t('common.twoFactorAuthentication'),
    value: '2FA'
  },
  {
    label: i18n.global.t('common.accountNotification'),
    value: 'ACCOUNT_NOTIFICATION'
  },
  {
    label: i18n.global.t('common.customerCare'),
    value: 'CUSTOMER_CARE'
  },
  {
    label: i18n.global.t('common.deliveryNotification'),
    value: 'DELIVERY_NOTIFICATION'
  },
  {
    label: i18n.global.t('common.fraudAlertMessaging'),
    value: 'FRAUD_ALERT'
  },
  {
    label: i18n.global.t('common.higherEducation'),
    value: 'HIGHER_EDUCATION'
  },
  {
    label: i18n.global.t('common.marketingAdvertising'),
    value: 'MARKETING'
  },
  {
    label: i18n.global.t('common.mixed'),
    value: 'MIXED'
  },
  {
    label: i18n.global.t('common.pollingAndVoting'),
    value: 'POLLING_VOTING'
  },
  {
    label: i18n.global.t('common.publicServiceAnnouncement'),
    value: 'PUBLIC_SERVICE_ANNOUNCEMENT'
  },
  {
    label: i18n.global.t('common.securityAlert'),
    value: 'SECURITY_ALERT'
  },
]

export const A2PStandardCampaignUseCaseOptions = [
  {
    label: i18n.global.t('common.mixedRecommended'),
    value: 'MIXED'
  },
  {
    label: i18n.global.t('common.twoFactorAuthentication'),
    value: '2FA'
  },
  {
    label: i18n.global.t('common.accountNotification'),
    value: 'ACCOUNT_NOTIFICATION'
  },
  {
    label: i18n.global.t('common.customerCare'),
    value: 'CUSTOMER_CARE'
  },
  {
    label: i18n.global.t('common.deliveryNotification'),
    value: 'DELIVERY_NOTIFICATION'
  },
  {
    label: i18n.global.t('common.fraudAlertMessaging'),
    value: 'FRAUD_ALERT'
  },
  {
    label: i18n.global.t('common.higherEducation'),
    value: 'HIGHER_EDUCATION'
  },
  {
    label: i18n.global.t('common.marketingAdvertising'),
    value: 'MARKETING'
  },
  {
    label: i18n.global.t('common.pollingAndVoting'),
    value: 'POLLING_VOTING'
  },
  {
    label: i18n.global.t('common.publicServiceAnnouncement'),
    value: 'PUBLIC_SERVICE_ANNOUNCEMENT'
  },
  {
    label: i18n.global.t('common.securityAlert'),
    value: 'SECURITY_ALERT'
  },
]

export const MonthlyMessageVolume = [
  {
    label: '10',
    value: '10'
  },
  {
    label: '100',
    value: '100'
  },
  {
    label: '1,000',
    value: '1,000'
  },
  {
    label: '10,000',
    value: '10,000'
  },
  {
    label: '100,000',
    value: '100,000'
  },
  {
    label: '250,000',
    value: '250,000'
  },
  {
    label: '500,000',
    value: '500,000'
  },
  {
    label: '750,000',
    value: '750,000'
  },
  {
    label: '1,000,000',
    value: '1,000,000'
  },
  {
    label: '5,000,000',
    value: '5,000,000'
  },
  {
    label: '10,000,000+',
    value: '10,000,000+'
  }
]

export const businessType = [
  {
    label: i18n.global.t('common.cooperative'),
    value: 'Co-operative',
  },
  {
    label: i18n.global.t('common.corporation'),
    value: 'Corporation',
  },
  {
    label: i18n.global.t('common.limitedLiabilityCompanyOr'),
    value: 'Limited Liability Corporation',
  },
  {
    label: i18n.global.t('common.nonprofitCorporation'),
    value: 'Non-profit Corporation',
  },
  {
    label: i18n.global.t('common.partnership'),
    value: 'Partnership',
  },
]

export const businessRegistrationType = [
  {
  label: i18n.global.t('common.usaEmployerIdentificationNumbe'),
  value: 'EIN'
},
  {
    label: i18n.global.t('common.canadaCanadianBusinessNumber'),
    value: 'CBN'
  },
  {
    label: i18n.global.t('common.indiaCorporateIdentityNumber'),
    value: 'CN'
  },
  {
    label: i18n.global.t('common.australiaCompanyNumberFrom'),
    value: 'ACN'
  },
  {
    label: i18n.global.t('common.greatBritainCompanyNumber'),
    value: 'CIN'
  },
  {
    label: i18n.global.t('common.estoniaVatNumber'),
    value: 'VAT'
  },
  {
    label: i18n.global.t('common.israelRegistrationNumber'),
    value: 'RN'
  },
  {
    label: i18n.global.t('common.other'),
    value: 'Other'
  }
]

export const jobPositionOptions = [
  {
    label: i18n.global.t('common.director'),
    value: 'Director',
  },
  {
    label: i18n.global.t('campaign.regulatoryBundle.a2p.options.jobPosition.gm'),
    value: 'GM',
  },
  {
    label: i18n.global.t('campaign.regulatoryBundle.a2p.options.jobPosition.vp'),
    value: 'VP',
  },
  {
    label: i18n.global.t('common.ceo'),
    value: 'CEO',
  },
  {
    label: i18n.global.t('common.cfo'),
    value: 'CFO',
  },
  {
    label: i18n.global.t('common.generalCounsel'),
    value: 'General Counsel',
  },
  {
    label: i18n.global.t('common.other'),
    value: 'Other',
  },
]

export const businessIndustry = [
  {
  label: 'Automotive',
  value: 'AUTOMOTIVE'
},
  {
    label: 'Agriculture',
    value: 'AGRICULTURE'
  },
  {
    label: 'Banking',
    value: 'BANKING'
  },
  {
    label: 'Consumer',
    value: 'CONSUMER'
  },
  {
    label: 'Education',
    value: 'EDUCATION'
  },
  {
    label: 'Engineering',
    value: 'ENGINEERING'
  },
  {
    label: 'Energy',
    value: 'ENERGY'
  },
  {
    label: 'Oil and Gas',
    value: 'OIL_AND_GAS'
  },
  {
    label: 'Fast moving consumer goods',
    value: 'FAST_MOVING_CONSUMER_GOODS'
  },
  {
    label: 'Financial',
    value: 'FINANCIAL'
  },
  {
    label: 'Fintech',
    value: 'FINTECH'
  },
  {
    label: 'Food and Beverage',
    value: 'FOOD_AND_BEVERAGE'
  },
  {
    label: 'Government',
    value: 'GOVERNMENT'
  },
  {
    label: 'Healthcare',
    value: 'HEALTHCARE'
  },
  {
    label: 'Hospitality',
    value: 'HOSPITALITY'
  },
  {
    label: 'Insurance',
    value: 'INSURANCE'
  },
  {
    label: 'Legal',
    value: 'LEGAL'
  },
  {
    label: 'Manufacturing',
    value: 'MANUFACTURING'
  },
  {
    label: 'Media',
    value: 'MEDIA'
  },
  {
    label: 'Online',
    value: 'ONLINE'
  },
  {
    label: 'Raw Materials',
    value: 'RAW_MATERIALS'
  },
  {
    label: 'Real Estate',
    value: 'REAL_ESTATE'
  },
  {
    label: 'Religion',
    value: 'RELIGION'
  },

  {
    label: 'Retail',
    value: 'RETAIL'
  },
  {
    label: 'Jewelry',
    value: 'JEWELRY'
  },
  {
    label: 'Technology',
    value: 'TECHNOLOGY'
  },
  {
    label: 'Telecommunications',
    value: 'TELECOMMUNICATIONS'
  },
  {
    label: 'Transportation',
    value: 'TRANSPORTATION'
  },
  {
    label: 'Travel',
    value: 'TRAVEL'
  },
  {
    label: 'Electronics',
    value: 'ELECTRONICS'
  },
  {
    label: 'Not for profit',
    value: 'NOT_FOR_PROFIT'
  }
]

export const businessVerticals = [
  {
    label: 'Agriculture',
    value: 'AGRICULTURE'
  },
  {
    label: 'Communication',
    value: 'COMMUNICATION'
  },
  {
    label: 'Construction',
    value: 'CONSTRUCTION'
  },
  {
    label: 'Education',
    value: 'EDUCATION'
  },
  {
    label: 'Energy',
    value: 'ENERGY'
  },
  {
    label: 'Entertainment',
    value: 'ENTERTAINMENT'
  },
  {
    label: 'Financial',
    value: 'FINANCIAL'
  },
  {
    label: 'Gambling',
    value: 'GAMBLING'
  },
  {
    label: 'Government',
    value: 'GOVERNMENT'
  },
  {
    label: 'Healthcare',
    value: 'HEALTHCARE'
  },
  {
    label: 'Hospitality',
    value: 'HOSPITALITY'
  },
  {
    label: 'Human Resources',
    value: 'HUMAN_RESOURCES'
  },
  {
    label: 'Insurance',
    value: 'INSURANCE'
  },
  {
    label: 'Legal',
    value: 'LEGAL'
  },
  {
    label: 'Manufacturing',
    value: 'MANUFACTURING'
  },
  {
    label: 'NGO',
    value: 'NGO'
  },
  {
    label: 'Political',
    value: 'POLITICAL'
  },
  {
    label: 'Postal',
    value: 'POSTAL'
  },
  {
    label: 'Professional',
    value: 'PROFESSIONAL'
  },
  {
    label: 'Real Estate',
    value: 'REAL_ESTATE'
  },
  {
    label: 'Retail',
    value: 'RETAIL'
  },
  {
    label: 'Technology',
    value: 'TECHNOLOGY'
  },
  {
    label: 'Transportation',
    value: 'TRANSPORTATION'
  }
];


export function generateRandomPassword(length: number = 12) {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyz@&ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let password = '';
  while (true) {
    password = '';
    const array = new Uint32Array(chars.length);
    window.crypto.getRandomValues(array);
    for (let i = 0; i < length; i++) {
      password += chars[array[i] % chars.length];
    }
    const upperCase = /[A-Z]+/.test(password)
    const lowerCase = /[a-z]+/.test(password)
    const number = /[0-9]+/.test(password)
    if(upperCase && lowerCase && number){
      break;
    }else{
      console.log('password not valid')
      continue;
    }
  }

  return password;
}

export function generateOtp(length: number = 4) {
  const chars = '0123456789';
  let otp = '';
  const array = new Uint32Array(chars.length);
  window.crypto.getRandomValues(array);
  for (let i = 0; i < length; i++) {
    otp += chars[array[i] % chars.length];
  }
  return otp;
}

export function getShareLink(shareId: string, referralId?: string) {
  let link = ''
  switch (config.mode) {
    case 'production': {
      link = `https://affiliates.gohighlevel.com/?fp_ref=${referralId}&share=${shareId}`
      break
    }
    case 'dev': {
      link = `http://localhost:8080/settings/snapshot/import/${shareId}`
      break
    }
    case 'staging': {
      link = `https://affiliate-dot-highlevel-staging.appspot.com/?fp_ref=${referralId}&share=${shareId}`
      break
    }
    case 'interop': {
      link = `https://affiliate-dot-highlevel-staging.appspot.com/?fp_ref=${referralId}&share=${shareId}`
      break
    }
    default: {
      link = `https://${window.location.hostname}/settings/snapshot/import/${shareId}`
    }
  }

  return link
}

export function convertObjKeysToSnakeRecursively(
  object: string,
  skipKeysFor?: string[]
) {
  if (isArray(object)) {
    return object.map(i => {
      return convertObjKeysToSnakeRecursively(i)
    })
  }
  else if (isObject(object)) {
    const n = {}
    Object.keys(object).forEach(k => {
      if(skipKeysFor && skipKeysFor.includes(k)) {
        n[snakeCase(k)] = null;
        return;
      }
      n[snakeCase(k)] = convertObjKeysToSnakeRecursively(object[k])
    })
    return n
  }
  return object
}

function formatObjectWithLocationsId(object) {
  const result = {};
  if(object)
  {
    Object.keys(object).map((key: string)=> {
    Object.assign(result,{[key]: convertObjKeysToSnakeRecursively(object[key])});
  })
}
  return result;
}

export function transformUserApiData(userApiData) {
  const userData = convertObjKeysToSnakeRecursively(userApiData, [
    'locationWiseOpenHours',
    'locations',
    'userCalendar',
    'locationWiseTimezone',
    'locationWiseMeetingLocation',
    'locationWiseZoomAdded',
    'twilioPhone'
  ])
  Object.assign(userData, {
    role: userData?.roles?.role,
    type: userData?.roles?.type,
    last_name_lower_case: userData?.last_name?.toLowerCase(),
    email_lower_case: userData?.email?.toLowerCase(),
    first_name_lower_case: userData?.first_name?.toLowerCase(),
    locations: formatObjectWithLocationsId(userApiData.locations),
    user_calendar: formatObjectWithLocationsId(userApiData.userCalendar),
    location_wise_open_hours: formatObjectWithLocationsId(userApiData.locationWiseOpenHours),
    location_wise_timezone: formatObjectWithLocationsId(userApiData.locationWiseTimezone),
    location_wise_meeting_location: formatObjectWithLocationsId(userApiData.locationWiseMeetingLocation),
    location_wise_zoom_added: formatObjectWithLocationsId(userApiData.locationWiseZoomAdded),
    location_wise_day_of_the_weekwise_availability: formatObjectWithLocationsId(userApiData.locationWiseDayOfTheWeekwiseAvailability),
    platformLanguage:userData?.platform_language,
    twilio_phone: formatObjectWithLocationsId(userApiData.twilioPhone)
  })
  return userData;
}

export function transformLocationApiData(locationApiData) {
  const locObj = convertObjKeysToSnakeRecursively(locationApiData.data)
  Object.assign(locObj, {
    gmb_business_scope_exist: locationApiData.gmbMessagingScopeExist,
    name_lower_case: locationApiData.name.toLowerCase()
  })
  return locObj;
}

export const formatPhoneNumberE164 = (phone: string, countryCode?: string) => parsePhoneNumber(phone, countryCode).format("E.164")



/**
 * This are our internal production company ids
 */
export const internalProductionCompanyIds = ['YuTUZlUtrwBtvmgByZDW', 'ktapXmiRvMM4pJHyN3b3'];

export const isInternalProdAccountOrStaging = (companyId: string) => {
  if(config.mode !== 'production') return true
  return internalProductionCompanyIds.includes(companyId)
}



export const addPrefixToKeyIfNotAlready = (prefix, fieldKey) => {
  // Check if 'fieldKey' already starts with 'model'
  if (fieldKey.startsWith(`${prefix}.`)) {
    // 'fieldKey' already has 'model' at the beginning, do nothing
  } else if (fieldKey.includes('.')) {
    // 'fieldKey' contains '.' but does not start with 'model.', throw an error
    throw new Error(`Invalid key - "${fieldKey}"`)
  } else {
    // 'model' does not contain '.', concatenate 'model' and 'fieldKey'
    fieldKey = `${prefix}.${fieldKey}`
  }

  return fieldKey
}


const retryStoreDataCheck = async (store, maxAttempts = 5, delay = 200) => {
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    if (store.state?.company?.company && store.state?.user?.user) {
      return true;
    }
    await new Promise(resolve => setTimeout(resolve, delay));
  }
  return false;
}

export const checkAndRedirectToSummerOfAI = async (
  {
    store,
    router,
    locationId,
    next,
    allowRedirect = true
  }: {
    store: any,
    router: any,
    locationId: string,
    next?: any,
    allowRedirect?: boolean
  }) => {
  try {
    return false;
    const hasStoreData = await promiseRace(retryStoreDataCheck(store), 1500);
    if (!hasStoreData) {
      console.warn('Store data not available after retries');
      return false;
    }

    const showSummerOfAIMenu = await store.dispatch('onboarding/checkAndSetSummerOfAI', {
      locationId,
      companyId: store.state?.company?.company?.id,
      companyStatus: store.state?.company?.company?.status,
      userRole: store.state?.user?.user?.role || 'admin'
    })

    if(showSummerOfAIMenu) {
      const params = locationId ? { location_id: locationId } : {}
      // if allowRedirect is false, we don't want to use redirection
      if(allowRedirect) {
        if(router) {
          router.push({
            name: locationId ? conversationAIRouteNames.aiEmployeePromoLocation : aiEmployeePromoRoutes.default,
            params,
          })
        } else {
          next({
            name: locationId ? conversationAIRouteNames.aiEmployeePromoLocation : aiEmployeePromoRoutes.default,
            params,
          })
        }
      }
      return true
    }

  } catch (error) {
    console.error(error)
  }
  return false
}

/**
 * Checks if user should be redirected to launchpad and redirects if needed
 * @param {Object} params - Function parameters
 * @param {Object} params.store - Vuex store instance
 * @param {Object} params.router - Vue router instance
 * @param {string} params.locationId - Location ID to check
 * @returns {Promise<boolean>} True if redirected, false otherwise
 */
export const checkAndRedirectToLaunchpad = async ({ store, router, locationId }) => {
  try {
    const hasStoreData = await promiseRace(retryStoreDataCheck(store, 5, 600), 2000)
    if (!hasStoreData) {
      console.warn('Store data not available after retries')
      return false
    }
    const companyId = store.state?.company?.company?.id

    if (companyId) {
      // First check for agency_launchpad
      if (store?.state?.user?.user?.type === 'agency' && store?.state?.user?.user?.role === 'admin') {
        const allowRedirect = await store.dispatch('launchpad/redirectToAgencyLaunchpad', { companyId })
        if (allowRedirect) {
          router.push({
            name: agencyLaunchpadRoutes.default
          })

          return true
        }
      }

      if(shouldHideLaunchpad(store?.state?.company?.company?.hide_launchpad,store?.getters?.['featureFlags/getForLocation']?.('location-launchpad-v2'))) {
        return false
      }

      // If agency_launchpad is not enabled check for location launchpad & redirect to location launchpad
      if (!locationId) {
        const onboardingInfo = await store.dispatch('onboarding/getOnboardingInfo', { companyId })
        locationId = onboardingInfo?.defaultLocationId
      }

      const locations = Object.keys(store.state?.user?.user?.locations);
      if(locations?.length > 0 && !locations?.includes(locationId)) { // this is for sub-account users having specific location access
        locationId = locations[0];
      }

      const allowRedirect = await store.dispatch('launchpad/redirectToLaunchpad', locationId)

      if (allowRedirect) {
        router.push({
          name: launchPadRouteNames.default,
          params: { location_id: locationId },
          replace: true,
        })

        return true
      }

      return false
    }
  } catch (error) {
    console.error(error)
  }
  return false
}

export const toMomentFormat = (ts) => {
  if (isEmpty(ts)) return moment(null);

  // Case 1: Firestore Timestamp instance
  if (typeof ts?.toDate === "function") {
    return moment(ts.toDate());
  }

  // Case 2: JSON-serialized timestamp
  if (typeof ts?.seconds === "number" && typeof ts?.nanoseconds === "number") {
    return moment(new Date(ts.seconds * 1000 + ts.nanoseconds / 1e6));
  }

  // Case 3: Already a Date or string
  return moment(ts);
}

export const copilotAvailableLocations = [
  'AaWbxwvWqBHfWOM6pNZJ',
  'ctblgQoCtv3uGAkOvp7U',
  'Dv2UariJ0rAWw2ngVYDT',
  '3xNz3SfsvagO5pEeGhIV',
  '2JXjCAOYLmZ19949rTar',
  'c3cmUrbBhdgs54adfIYP',
  'RQC3BzSUBwWt4oAMiUJZ',
  '4oQbAECu3nQkg0BLKTWW',
  'EOxj6dlZ2LYJMwopMe3g',
  'QYPEM1LCLATiHmyFkzX2',
  'VsCb4ghBsfQSahsP0ofT',
  'migSbzcKuUXdcTezfcLD',
  'TmAf7CvvlFe1Z8avWuQT',
  'G349LojwqNQv1CrFW5PH',
  '8eDg4i6sYdAHm9OBhZXj',
  '2JKvoEm8ORcNEAVdhLJj',
  'WyxpdA3QJX3QIHqAeQlU',
  'WhYhhwftKkxIk45vmUGU',
  'Fq3AmwDFsinfrDmXMbJn'
]
